import { CapabilityJson } from './getCapabilitySetJson';

export const getMyNeedResolutionList = (
  resolutionSet: CapabilityJson['分辨率']['list']
) => {
  const resolutionReSet = resolutionSet.map((item) => {
    const { comment, value } = item;
    const curSize = comment.match(/[0-9]{1,}\*[0-9]{1,}/)?.[0] ?? '';
    return { resolution: curSize, comment: comment, value };
  });
  return resolutionReSet;
};

export const getResolution = (
  capabilityWholeSet: CapabilityJson,
  size: string
) => {
  // 由于466*466和464*464共用，所以这里改为466*466
  if (size == '464*464') size = '466*466';

  const resolutionList = getMyNeedResolutionList(
    capabilityWholeSet['分辨率'].list
  );

  const findResolution = resolutionList.find((item) => {
    return item.resolution === size;
  });

  return findResolution?.value;
};
